<template>
  <span>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list rounded>
        <template v-for="item in items">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
          </v-row>

          <v-divider
            v-else-if="item.divider"
            :key="item.title"
            dark
            class="my-4"
          ></v-divider>

          <v-list-group
            v-else-if="item.children"
            :key="item.title"
            v-model="item.model"
            color="primary"
          >
            <template v-slot:activator>
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" @click="">
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <router-link :to="{ path: child.link }">
                  <v-list-item-title>
                    {{ child.title }}
                  </v-list-item-title>
                </router-link>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item v-else :key="item.title" @click="">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-toolbar-title style="width: 400px" class="ml-0 pl-4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer">
        </v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">{{ appTitle }}</span>
      </v-toolbar-title>

      <router-link :to="{ name: 'insurance' }">
        <v-btn
          v-if="
            unit_code === 'ADM' || unit_code === 'ITD' || unit_code === 'AUD'
          "
          text
          >HR</v-btn
        >
      </router-link>

      <div class="flex-grow-1"></div>
      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
      <v-btn icon large class="logout_btn">
        <router-link :to="{ name: 'sign-out' }">
          <v-icon>mdi-logout</v-icon></router-link
        >
      </v-btn>
      <span>{{ userName }}</span>
      <v-btn icon large>
        <v-icon>mdi-account-circle</v-icon>
      </v-btn>
    </v-app-bar>
  </span>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import JwtService from "@/services/jwt.service";
import ModuleAccessService from "@/services/access-module.service";
export default {
  name: "AppNavigation",
  props: {
    source: String
  },
  data: () => ({
    appTitle: "GPA Portal",
    unit_code: null,
    dialog: false,
    drawer: null,
    //user_scopes: [],
    items: [
      //{ heading: 'Modules' },
      { divider: true },
      {
        icon: "mdi-anchor",
        "icon-alt": "mdi-arrow-down",
        title: "Harbour",
        model: false,
        unit_access: "HAR",
        children: [
          {
            icon: "mdi-file-document",
            title: "Chief Pilot Log",
            link: "chief-pilot-log"
          },
          { icon: "mdi-file-document", title: "Radio Log", link: "radio-log" },
          { icon: "mdi-cash", title: "Payments", link: "payment-charges" }
        ]
      },
      {
        icon: "mdi-traffic-light",
        "icon-alt": "mdi-arrow-down",
        title: "Terminals",
        model: false,
        children: [
          {
            icon: "mdi-file-document",
            title: "Manifest",
            link: "manifest",
            unit_access: "CSD"
          },
          // { icon: "mdi-chevron-right", title: "Import & Transit" },
          //{ icon: "mdi-chevron-right", title: "Export" },
          { icon: "mdi-chevron-right", title: "Rating" },
          { icon: "mdi-chevron-right", title: "Planning" },
          { icon: "mdi-chevron-right", title: "Car Port" },
          { icon: "mdi-file-excel", title: "Reporting", link: "reporting" }
        ]
      },
      /* {
        icon: "mdi-security",
        "icon-alt": "mdi-arrow-down",
        title: "Security",
        model: false,
        children: [
          { icon: "mdi-plus", title: "Visitors Log" },
          { icon: "mdi-plus", title: "Truck Entry & Exit Log" }
        ]
      },*/
      {
        icon: "mdi-wrench",
        "icon-alt": "mdi-arrow-down",
        title: "Settings",
        model: false,
        children: [
          {
            icon: "mdi-wrench",
            title: "General",
            link: "general-settings",
            unit_access: "CSD"
          },
          { icon: "mdi-cash", title: "Rates", link: "settings-rates" },
          { icon: "mdi-account-multiple", title: "Users", link: "users" }
        ]
      }
    ]
  }),
  computed: {
    ...mapGetters({
      current_user: "users/userName",
      scopes: "users/userScopes"
    }),
    loggedIn() {
      return this.$store.getters["users/loggedIn"];
    },
    userName() {
      return JwtService.getUser()
        ? JwtService.getUser()["user_firstname"] +
            " " +
            JwtService.getUser()["user_lastname"]
        : ""; // this.$store.getters["users/userName"];
    }
  },
  created() {
    // this.unit_code = ModuleAccessService.getDepartmentCode("CSD");
    //console.log(this.user_scopes);
  },
  mounted() {
    if (ModuleAccessService.getDepartmentCode()) {
      this.unit_code = ModuleAccessService.getDepartmentCode();
    } else this.unit_code = null;
  },
  methods: {
    createLinks() {
      let links = [];
      for (let i = 0; i < this.user_scopes.length; i++) {
        links[i] = { icon: "mdi-chevron-right", title: i, link: i };
      }
      return links;
    }
  }
};
</script>
<style scoped>
.logout_btn {
  color: white !important;
  text-decoration: none;
}
a {
  text-decoration: none;
}
</style>
